/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Update_ShortformInputs */



/**
* | output |
* | --- |
* | "Update Shortform" |
*
* @param {Update_ShortformInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const update_shortform = /** @type {((inputs?: Update_ShortformInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Update_ShortformInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mettre à jour l'abréviation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Kurzform aktualisieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiorna Shortform")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обновить краткую форму")
	if (locale === "es") return /** @type {LocalizedString} */ ("Actualizar formato corto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("更新简表")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ショートフォームを更新")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संक्षिप्त रूप को अपडेट करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atualizar formulário abreviado")
	return /** @type {LocalizedString} */ ("Update Shortform")
});